import clsx from 'clsx';
import React from 'react';
import { factory } from '../../../factory/factory.utils.mjs';
import { Box } from '../../../Other/Box/Box.mjs';
import { InlineStyles } from '../../../Other/InlineStyles/InlineStyles.mjs';
import { parseStyleProps } from '../../../utils/styleProps.mjs';
import { useRandomClassName } from '../../../utils/hooks/hooks.mjs';
import classes from '../Grid.module.css.mjs';
import { GRID_COLUMN_STYLE_PROPS_DATA } from './GridColumn.utils.mjs';

const GridColumn = factory((props, ref) => {
  const { className, span, spanSmall, gridColumnStart, gridColumn, gridColumnEnd, fullWidth = true, style, ...rest } = props;
  const responsiveClassName = useRandomClassName();
  const parsedStyleProps = parseStyleProps({
    styleProps: { gridColumn, gridColumnStart, gridColumnEnd },
    data: GRID_COLUMN_STYLE_PROPS_DATA
  });
  const styleVars = {
    ...span ? { ["--span"]: String(span) } : {},
    ...spanSmall ? { ["--span-small"]: String(spanSmall) } : {}
  };
  const parsedStyles = {
    ...style,
    ...styleVars,
    ...!parsedStyleProps.hasResponsiveStyles ? parsedStyleProps.inlineStyles : {}
  };
  const classNames = clsx(
    className,
    !span && !spanSmall && fullWidth && classes.gridColumnFull,
    span && classes.gridColumnSpan,
    spanSmall && classes.gridColumnSpanSmall
  );
  return /* @__PURE__ */ React.createElement(React.Fragment, null, parsedStyleProps.hasResponsiveStyles && /* @__PURE__ */ React.createElement(InlineStyles, { selector: `.${responsiveClassName}`, styles: parsedStyleProps.styles, media: parsedStyleProps.media }), /* @__PURE__ */ React.createElement(Box, { ref, className: classNames, ...rest, style: parsedStyles }));
});

export { GridColumn };
